import { render, staticRenderFns } from "./addNatural.vue?vue&type=template&id=7efbdcac&scoped=true&"
import script from "./addNatural.vue?vue&type=script&lang=js&"
export * from "./addNatural.vue?vue&type=script&lang=js&"
import style0 from "./addNatural.vue?vue&type=style&index=0&id=7efbdcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efbdcac",
  null
  
)

export default component.exports